import { render, staticRenderFns } from "./PaymentNetaxept.vue?vue&type=template&id=200365da&"
import script from "./PaymentNetaxept.vue?vue&type=script&lang=js&"
export * from "./PaymentNetaxept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports